import { DataChannelEvent, RemoteParticipant } from "@domain";
import { BasePeerCommand } from "./BasePeerCommand";

export class AddDataChannelCommand extends BasePeerCommand {
  public execute(e: CustomEvent<DataChannelEvent>): void {
    const room = this.getRoom();
    const event = e.detail;
    const remoteParticipant = room.remoteParticipants.getParticipantByRemoteId(
      event.peer.userRemoteId
    ) as RemoteParticipant;
    if (remoteParticipant === null) {
      console.warn("Remote participant not found");
      return;
    }
    remoteParticipant.peer.dataChannel = event.channel;
  }
}
